import { DATADOG_APPLICATION_ID, DATADOG_CLIENT_TOKEN } from './config';

/**
 * RUM credentials are baked in at build time, so an image built without them can
 * never initialize the SDK. Anything that talks to RUM has to check this first,
 * or it buffers calls into an SDK that will never flush them.
 */
export function isRumConfigured(): boolean {
    return Boolean(DATADOG_APPLICATION_ID && DATADOG_CLIENT_TOKEN);
}
